module.exports = __webpack_public_path__ + "img/fuwu3.9b549272.png";